import { css } from 'emotion';

export namespace styles {
  export const container = (centered?: boolean, color: string = '#fff') =>
    css({
      overflow: 'hidden',
      position: 'relative',
      margin: '0px',
      padding: '6.5px 20px',
      backgroundColor: color,
      color: '#333',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      fontSize: '18px',
      letterSpacing: '.3px'
    });

  export const h3 = css({});

  export const exitButton = css({
    width: '15px',
    height: '15px',
    top: '1em',
    right: '1em',
    cursor: 'pointer',
    position: 'absolute',
    ' svg': {
      width: '100%',
      height: 'auto',
      ' path': {
        fill: 'white'
      }
    }
  });
}
